import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Component({
  selector: 'app-pda-shipping',
  templateUrl: './pda-shipping.component.html',
  styleUrls: ['./pda-shipping.component.scss']
})
export class PdaShippingComponent implements OnInit {

  constructor(
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/shipping/pda-shipping.component.ts